import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { PortalAppState } from "../../../store/reducer";
import { Store } from "@ngrx/store";
import { LoginAction } from "common-lib";

@Component({
    selector: 'login-page',
    templateUrl: './login.page.html',
    styleUrls: ['./login.page.scss'],
    standalone: false
})
export class LoginPage {

  form: UntypedFormGroup;

  constructor(
    protected store: Store<PortalAppState>,
  ) {
    let defaultName = '';
    let defaultPassword = '';
    this.form = new UntypedFormGroup({
      userName: new UntypedFormControl(defaultName, {
        validators: [Validators.required],
        updateOn: "submit"
      }),
      password: new UntypedFormControl(defaultPassword, {
        validators: [Validators.required],
        updateOn: "submit"
      })
    });
  }

  submitLogin(loginForm) {
    console.log('login submit');
    // const login = {
    //   userName: loginForm.userName,
    //   password: loginForm.passive
    // };
    this.store.dispatch(new LoginAction(loginForm))
  }
}
